export default "__VITE_ASSET__da969cf9__"